<template>
  <div class="background_white flex wrap_mobile container-large" v-if="article">
    <div class="col-12 md-col-6 left-panel">
      <div v-for="(media, index) in article.acf.medias" :key="media.id" @click="currentMediaIndex = index" class="my2 relative" :class="{fullscreen: fullscreen && currentMediaIndex === index}" :style="{display: currentMediaIndex === index ? 'block' : 'none'}">
        <img v-if="media.mime_type.indexOf('image') !== -1" :src="media.url" style="max-width: 100%; display: block; cursor: pointer;" class="image" @click="fullscreen = !fullscreen" />
        <video ref="video" :data-media-id="index" v-else :src="media.url" style="max-width: 100%;" controls playsinline></video>
        <img src="/images/fullscreen.png" class="full-screen-icon" v-if="media.mime_type.indexOf('image') !== -1 && !fullscreen" @click="fullscreen = true" />
        <img src="/images/close.png" class="close-icon" v-if="media.mime_type.indexOf('image') !== -1 && fullscreen" @click="fullscreen = false" />
      </div>
      <!--<img v-if="article.acf.medias[currentMediaIndex].mime_type.indexOf('image') !== -1" :src="article.acf.medias[currentMediaIndex].url" style="max-width: 100%;" class="my2" />-->
      <!--<video v-else :src="article.acf.medias[currentMediaIndex].url" style="max-width: 100%;" controls class="my2"></video>-->

      <div class="row wrap">
        <div v-for="(media, index) in article.acf.medias" :key="media.id" class="col-4" style="cursor: pointer;" @click="setCurrentMedia(index, media.mime_type.indexOf('image') !== -1)">
          <img v-if="media.mime_type.indexOf('image') !== -1" :src="media.url" style="max-width: 100%; display: block;" />
          <img v-else-if="isIOS()" src="/images/play.png" style="max-width: 100%; display: block;" />
          <video v-else :src="media.url" style="max-width: 100%;" playsinline></video>
        </div>
      </div>
    </div>
    <div class="flex column col-12 md-col-6 pt2 reduce_font">
      <div class="caps black h2 smaller italic" v-html="copyright(article.title.rendered)"></div>
      <p class="foot_title" v-html="copyright(article.content.rendered)"></p>
      <div class="justify-start flex foot_title" style="line-height: 30px;">
        <div class="flex column md-col-2 col-3 bold">
          <span>{{$store.state.translations.client}}</span>
          <span>{{$store.state.translations.expertise}}</span>
          <span>{{$store.state.translations.annee}}</span>
        </div>
        <div class="flex column">
          <span v-html="copyright(article.acf.client)"></span>
          <span>{{article.acf.expertise}}</span>
          <span>{{article.acf.annee}}</span>
        </div>
      </div>
      <div class="justify-start flex mt2">
        <div class="flex column md-col-2 col-3 bold">
          <span>{{$store.state.translations.partager}}</span>
        </div>
        <div class="flex share-logos mb2">
          <a :href="shareLink('facebook')" target="_blank"><img src="/images/share/facebook.png" /></a>
          <a :href="shareLink('twitter')" target="_blank"><img src="/images/share/twitter.png" /></a>
          <a :href="shareLink('pinterest')" target="_blank"><img src="/images/share/pinterest.png" /></a>
          <a :href="shareLink('linkedin')" target="_blank"><img src="/images/share/linkedin.png" /></a>
          <a :href="shareLink('xing')" target="_blank"><img src="/images/share/xing.png" /></a>
          <a :href="shareLink('telegram')" target="_blank"><img src="/images/share/telegram.png" /></a>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="stylus">
@import '../css/variables'
.share-logos
  align-items center
  img
    height 20px
    margin-right 10px

.left-panel
  @media tablet-up
    margin-right 1rem

video
  outline none

.full-screen-icon
  position absolute
  right 25px
  bottom 25px
  width 20px
  cursor pointer
  &:hover
    opacity 0.8

.close-icon
  position absolute
  right 10px
  top 10px
  width 40px
  cursor pointer
  background-color rgba(0, 0, 0, 0.2)
  border-radius 50%
  &:hover
    opacity 0.8

.fullscreen
  position fixed
  top 0
  left 0
  right 0
  bottom 0
  z-index 99999
  margin 0
  display flex !important
  justify-content center
  align-items center
  background-color white
  .image
    max-width 100%
    max-height 100%
</style>

<script>
export default {
  data () {
    return {
      shares: {
        facebook: 'https://www.facebook.com/sharer/sharer.php?u={url}',
        twitter: 'https://twitter.com/home?status={url} ',
        pinterest: 'https://pinterest.com/pin/create/button/?url={url}&media=&description=',
        linkedin: 'https://www.linkedin.com/shareArticle?mini=true&url={url}&title=&summary=&source=',
        xing: 'https://www.xing.com/spi/shares/new?url={url}',
        telegram: 'https://telegram.me/share/url?url={url}'
      },
      currentMediaIndex: 0,
      fullscreen: false
    }
  },
  computed: {
    article () {
      if (!this.$store.state.articles.length) {
        return null;
      }
      return this.$store.state.articles.find(a => a.slug === this.$route.params.id);
    }
  },
  methods: {
    shareLink(site) {
      return this.shares[site].replace('{url}', window.location);
    },
    copyright (a) {
      return a.replace(/®/g, '<sup style="line-height: 0;">®</sup>');
    },
    setCurrentMedia (index, isImage) {
      this.$refs.video.forEach(v => {
        v.pause();
      });
      this.currentMediaIndex = index;
      if (!isImage) {
        this.$refs.video.forEach(v => {
          if (parseInt(v.dataset.mediaId) === parseInt(index)) {
            v.play();
          }
        });
      }
    },
    isIOS () {
      return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    }
  }
};
</script>